// Read-only on a business: they come from its registration, set via registrationId.
export const REGISTRATION_FIELDS = [
  "abn",
  "acn",
  "abrLastChecked",
  "isABNActive",
  "isGSTRegistered",
  "tradingName",
] as const;

export interface RegistrationFields {
  abn: string;
  acn: string;
  abrLastChecked: string | null;
  isABNActive: boolean | null;
  isGSTRegistered: boolean | null;
  tradingName: string;
}

const getRegistrationFields = (
  registration: BusinessRegistration | null | undefined,
): RegistrationFields => ({
  abn: registration?.abn ?? "",
  acn: registration?.acn ?? "",
  abrLastChecked: registration?.abrLastChecked ?? null,
  isABNActive: registration?.isABNActive ?? null,
  isGSTRegistered: registration?.isGSTRegistered ?? null,
  tradingName: registration?.tradingName ?? "",
});

/**
 * The business with its registration's ABN/ACN and ABR details, for code that
 * reads them off the business (grids, GST helpers, forms).
 */
export const withRegistration = <T extends { registrationId?: string | null }>(
  business: T,
  registrationsById: Record<string, BusinessRegistration>,
): T & RegistrationFields =>
  business && {
    ...business,
    ...getRegistrationFields(
      business.registrationId
        ? registrationsById[business.registrationId]
        : null,
    ),
  };
